import { render } from "./MobileFaQ.vue?vue&type=template&id=38bdf8e0"
import script from "./MobileFaQ.vue?vue&type=script&lang=js"
export * from "./MobileFaQ.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9acfb15ce118456a03f39fb117bb0076/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__